'use client'
import React from 'react';
import classes from "./Footer.module.scss";
import Image from "next/image";
import LogoWhite from "@/app/assets/images/footer/Logo.png";
import Link from "next/link";
import facebookIcon from "@/app/assets/images/icons/social/facebook.svg";
import instagramIcon from "@/app/assets/images/icons/social/instagram.svg";
import linkedinIcon from "@/app/assets/images/icons/social/linkedin.svg";
import allSecure from "@/app/assets/images/footer/allSecure/allsecure.svg";
import maestro from "@/app/assets/images/footer/allSecure/maestro.svg";
import master from "@/app/assets/images/footer/allSecure/master.svg";
import masterId from "@/app/assets/images/footer/allSecure/mc_idcheck.svg";
import visa from "@/app/assets/images/footer/allSecure/visa-cof-white.svg";
import visaSecure from "@/app/assets/images/footer/allSecure/visa_secure.svg";
import ckbLogo from "@/app/assets/images/footer/allSecure/footer_ckb_banka.png";
import {useTranslation} from "react-i18next";

function Footer({locale}) {
    const {t} = useTranslation();

    return (<footer className={classes.footer}>
            <div className={classes.linksAndSocial}>
                <Image src={LogoWhite} alt={'logoWhite'}/>
                {/*<div>*/}
                {/*    <Link className={classes.socialLink} href={'#'}>{t('footer.marketing')}</Link>*/}
                {/*    <Link className={classes.socialLink} href={'#'}>{t('footer.e-comm')}</Link>*/}
                {/*    <Link className={classes.socialLink} href={'#'}>IT</Link>*/}
                {/*    <Link className={classes.socialLink} href={'#'}>{t('footer.blockchain')}</Link>*/}
                {/*    <Link className={classes.socialLink} href={'#'}>{t('footer.construction')}</Link>*/}
                {/*    <Link className={classes.socialLink} href={'#'}>{t('footer.automotive')}</Link>*/}
                {/*</div>*/}
                <div className={classes.social}>
                    <Link href={'https://www.facebook.com/people/SeekIntro/61555820927807/?mibextid=LQQJ4d'}
                          target={'_blank'}><Image src={facebookIcon} alt={'facebookIcon'}/></Link>
                    <Link
                        href={'https://www.instagram.com/accounts/login/?next=https%3A%2F%2Fwww.instagram.com%2Fseekintro%2F%3Figsh%3DOHpwdjZ3bmluMDJ2&is_from_rle'}
                        target={'_blank'}><Image src={instagramIcon} alt={'instagramIcon'}/></Link>
                    {/*<Image src={twitterIcon} alt={'xIcon'}/>*/}
                    <Link href={'https://www.linkedin.com/company/seekintro/'} target={'_blank'}><Image
                        src={linkedinIcon} alt={'linkedinIcon'}/></Link>
                </div>
            </div>
            <div className={classes.allSecure}>
                <Image src={visa} alt={'card icon'}/>
                <Image src={maestro} alt={'card icon'}/>
                <Image src={master} alt={'card icon'}/>
                <Link href={'https://www.allsecure.rs/'} target={"_blank"} className={classes.widerImg}>
                    <Image src={allSecure} alt={'card icon'}/>
                </Link>
                <Link className={classes.widerImg} href={'https://www.ckb.me/gradjani/gradjani-home'} target={"_blank"}>
                    <Image src={ckbLogo} alt={'card icon'}/>
                </Link>
                <Link className={classes.masterId}
                      href={'https://www.mastercard.us/en-us/merchants/safety-security/securecode.html'}
                      target={'_blank'}>
                    <Image src={masterId} alt={'card icon'}/>
                </Link>
                <Link href={'https://www.visa.ca/en_CA/run-your-business/merchant-resources/verified-by-visa.html'}
                      target={'_blank'}>
                    <Image src={visaSecure} alt={'card icon'}/>
                </Link>
            </div>
            <div className={classes.rules}>
                <span>	&#169;{new Date().getFullYear()} All rights reserved</span>
                <Link href={'https://api.seekintro.com/privacy-policy.html'}
                      target={'_blank'}>{t('footer.privacyPolicy')}</Link>
                <Link href={'https://seekintro-api.amplitudo.me/terms_of_use.pdf'}
                      target={'blank'}>{t('footer.termsOfService')}</Link>
                {/*<Link href={'#'}>{t('footer.cookiesSettings')}</Link>*/}
            </div>
        </footer>);
}

export default Footer;